module.exports = __webpack_public_path__ + "img/himanshu.607a8b08.jpeg";